import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

function Testimonials() {
    const { t, i18n } = useTranslation();
    useEffect(() => {
        // Initialize Swiper when the component mounts
        if (window.Swiper) {
            const swiperReviews = new window.Swiper(".reviews__swiper", {
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                    type: "bullets"
                },
                loop: true, // {{ edit_1 }} Enable looping
                autoplay: { // {{ edit_2 }} Enable autoplay
                    delay: 1000, // Delay between transitions in milliseconds
                    disableOnInteraction: false, // Continue autoplay after user interactions
                    stopOnLastSlide: false
                },
                breakpoints: {
                    320: {
                        direction: "horizontal",
                        slidesPerView: 1.2,
                        spaceBetween: 40
                    },
                    640: {
                        direction: "horizontal",
                        slidesPerView: 2.2,
                        spaceBetween: 40
                    },
                    1000: {
                        direction: "vertical",
                        slidesPerView: "auto",
                        freeMode: true,
                        mousewheel: true,
                        spaceBetween: 32,
                        centeredSlides: true
                    }
                },
                on: {
                    touchStart: function () {
                        console.log('touchStart');
                        this.autoplay.stop();  // Stop autoplay immediately on touch start
                    }
                }
            });
            swiperReviews.autoplay.start();
        } else {
            console.error("Swiper is not loaded on the page.");
        }
    }, []); // Empty dependency array ensures this runs only once

    return (
        <main className="main">
            <section className="reviews">
                <div className="reviews__container container">
                    <div className="reviews__content">
                        <h1 className="reviews__title">{t('What our happy customers say')}</h1>
                        <blockquote className="reviews__quote">
                            <p>
                                {t('Thanks for the great service.')} <br />
                                {t('This is simply unbelievable!')} <br />
                                {t('The best one on the net!')}
                            </p>
                        </blockquote>
                        <a className="button button--primary reviews__btn" href="##" data-da=".reviews__container, 1000, 2">{t('See for Yourself')}</a>
                    </div>
                    <div className="reviews__swiper swiper">
                        <ul className="reviews__list swiper-wrapper">
                            <li className="reviews__item reviews-item swiper-slide">
                                <div className="reviews-item__header">
                                    <img className="reviews-item__userpic" src="./assets/img/reviews/01.jpg" alt="Brooklyn Simmons" /><span className="reviews-item__name">{t('name1')}</span>
                                    <div className="reviews-item__rating">
                                        <img src="./assets/img/icons/star.svg" alt="star" />
                                        <img src="./assets/img/icons/star.svg" alt="star" />
                                        <img src="./assets/img/icons/star.svg" alt="star" />
                                        <img src="./assets/img/icons/star.svg" alt="star" />
                                        <img src="./assets/img/icons/star.svg" alt="star" />
                                    </div>
                                </div>
                                <div className="reviews-item__text">
                                    <p>
                                        {t('testimonial1')}
                                    </p>
                                </div>
                            </li>
                            <li className="reviews__item reviews-item swiper-slide">
                                <div className="reviews-item__header">
                                    <img className="reviews-item__userpic" src="./assets/img/reviews/02.jpg" alt="Alice Swenson" /><span className="reviews-item__name">{t('name2')}</span>
                                    <div className="reviews-item__rating">
                                        <img src="./assets/img/icons/star.svg" alt="star" />
                                        <img src="./assets/img/icons/star.svg" alt="star" />
                                        <img src="./assets/img/icons/star.svg" alt="star" />
                                        <img src="./assets/img/icons/star.svg" alt="star" />
                                        <img src="./assets/img/icons/star.svg" alt="star" />
                                    </div>
                                </div>
                                <div className="reviews-item__text">
                                    <p>
                                    {t('testimonial2')}
                                    </p>
                                </div>
                            </li>
                            <li className="reviews__item reviews-item swiper-slide">
                                <div className="reviews-item__header">
                                    <img className="reviews-item__userpic" src="./assets/img/reviews/review3.png" alt="Marcus Ferera" /><span className="reviews-item__name">{t('name3')}</span>
                                    <div className="reviews-item__rating">
                                        <img src="./assets/img/icons/star.svg" alt="star" />
                                        <img src="./assets/img/icons/star.svg" alt="star" />
                                        <img src="./assets/img/icons/star.svg" alt="star" />
                                        <img src="./assets/img/icons/star.svg" alt="star" />
                                        <img src="./assets/img/icons/star.svg" alt="star" />
                                    </div>
                                </div>
                                <div className="reviews-item__text">
                                    <p>
                                    {t('testimonial3')}
                                    </p>
                                </div>
                            </li>
                            <li className="reviews__item reviews-item swiper-slide">
                                <div className="reviews-item__header">
                                    <img className="reviews-item__userpic" src="./assets/img/reviews/01.jpg" alt="Brooklyn Simmons" /><span className="reviews-item__name">{t('name4')}</span>
                                    <div className="reviews-item__rating">
                                        <img src="./assets/img/icons/star.svg" alt="star" />
                                        <img src="./assets/img/icons/star.svg" alt="star" />
                                        <img src="./assets/img/icons/star.svg" alt="star" />
                                        <img src="./assets/img/icons/star.svg" alt="star" />
                                        <img src="./assets/img/icons/star.svg" alt="star" />
                                    </div>
                                </div>
                                <div className="reviews-item__text">
                                    <p>
                                    {t('testimonial4')}
                                    </p>
                                </div>
                            </li>
                            <li className="reviews__item reviews-item swiper-slide">
                                <div className="reviews-item__header">
                                    <img className="reviews-item__userpic" src="./assets/img/reviews/02.jpg" alt="Alice Swenson" /><span className="reviews-item__name">{t('name5')}</span>
                                    <div className="reviews-item__rating">
                                        <img src="./assets/img/icons/star.svg" alt="star" />
                                        <img src="./assets/img/icons/star.svg" alt="star" />
                                        <img src="./assets/img/icons/star.svg" alt="star" />
                                        <img src="./assets/img/icons/star.svg" alt="star" />
                                        <img src="./assets/img/icons/star.svg" alt="star" />
                                    </div>
                                </div>
                                <div className="reviews-item__text">
                                    <p>
                                    {t('testimonial5')}
                                    </p>
                                </div>
                            </li>
                        </ul>
                        <div className="swiper-pagination"></div>
                    </div>
                </div>
            </section>
        </main>
    );
}

export default Testimonials;
